import stripHtmlFromString from './stripHtmlFromString';

const getImageAltText = (image: Partial<PlaceImage>, placeName: string, countryName: string) => {
  const imageName = stripHtmlFromString(image.description || image.wikiObjectName || '');

  return imageName ? `${imageName} | ${placeName} in ${countryName}` : `Image of ${placeName} in ${countryName}`;
};

export default getImageAltText;
